import { createApp } from 'vue';
import FreePTable from '../../talent/PTable.vue'

const appElements = document.querySelectorAll('.vue-render-planetry-table')

Array.from(appElements).forEach(element => {
  createApp(FreePTable).mount(element);
});